import React from 'react'

interface DescriptionProps {
  style?: object
  fill?: string
  width?: string
  height?: string
  className?: string
  viewBox?: string
}

const Description = ({
  style = {},
  fill = '#1D70B6',
  width = '18px',
  height = '16px',
  className = '',
  viewBox = '0 0 18 16'
}: DescriptionProps) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M1.85746 0.5C1.19973 0.5 0.666992 1.01635 0.666992 1.65385V2.23077V3.96154V11.5256C0.666992 12.4461 1.41318 13.1923 2.33366 13.1923H9.10258L10.293 12.0385H1.85746V2.29487H14.9526V7.64731C15.2246 7.50654 15.5259 7.42308 15.8431 7.42308C15.9449 7.42308 16.0449 7.43625 16.1431 7.45125V3.38462V1.65385C16.1431 1.01635 15.6103 0.5 14.9526 0.5H1.85746ZM4.2384 5.69231C4.08053 5.69231 3.92913 5.75309 3.8175 5.86128C3.70587 5.96948 3.64316 6.11622 3.64316 6.26923C3.64316 6.42224 3.70587 6.56898 3.8175 6.67718C3.92913 6.78537 4.08053 6.84615 4.2384 6.84615C4.39626 6.84615 4.54766 6.78537 4.65929 6.67718C4.77092 6.56898 4.83363 6.42224 4.83363 6.26923C4.83363 6.11622 4.77092 5.96948 4.65929 5.86128C4.54766 5.75309 4.39626 5.69231 4.2384 5.69231ZM6.61933 5.69231C6.29076 5.69231 6.0241 5.95077 6.0241 6.26923C6.0241 6.58769 6.29076 6.84615 6.61933 6.84615H11.9764C12.305 6.84615 12.5717 6.58769 12.5717 6.26923C12.5717 5.95077 12.305 5.69231 11.9764 5.69231H6.61933ZM4.2384 8C4.08053 8 3.92913 8.06078 3.8175 8.16898C3.70587 8.27717 3.64316 8.42391 3.64316 8.57692C3.64316 8.72993 3.70587 8.87667 3.8175 8.98487C3.92913 9.09306 4.08053 9.15385 4.2384 9.15385C4.39626 9.15385 4.54766 9.09306 4.65929 8.98487C4.77092 8.87667 4.83363 8.72993 4.83363 8.57692C4.83363 8.42391 4.77092 8.27717 4.65929 8.16898C4.54766 8.06078 4.39626 8 4.2384 8ZM6.61933 8C6.29076 8 6.0241 8.25846 6.0241 8.57692C6.0241 8.89538 6.29076 9.15385 6.61933 9.15385H11.9764C12.305 9.15385 12.5717 8.89538 12.5717 8.57692C12.5717 8.25846 12.305 8 11.9764 8H6.61933ZM15.8431 8.57692C15.6604 8.57692 15.4782 8.64446 15.3386 8.77975L14.834 9.26878L16.6197 10.9995L17.1243 10.5105C17.4035 10.2399 17.4035 9.8019 17.1243 9.53132L16.3489 8.77975C16.2093 8.64446 16.0259 8.57692 15.8431 8.57692ZM14.1191 9.96176L11.2626 12.7303L11.7974 12.9038L11.9764 13.7692L12.8693 13.9428L13.0483 14.4611L15.9048 11.6925L14.1191 9.96176ZM16.1431 13.0931L16.0408 13.1923H16.1431V13.0931ZM10.6023 14.1681L10.2059 15.2577L10.2047 15.26V15.2611C10.1957 15.2818 10.191 15.304 10.1907 15.3265C10.1907 15.3493 10.1953 15.3719 10.2042 15.3929C10.2132 15.414 10.2264 15.4332 10.243 15.4493C10.2597 15.4654 10.2794 15.4782 10.3012 15.4869C10.3229 15.4956 10.3462 15.5001 10.3698 15.5C10.3912 15.4999 10.4125 15.4961 10.4326 15.4887H10.4337L11.5649 15.1011L10.6023 14.1681Z"
    />
  </svg>
)

export default Description
